module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/battle-payments-clan-landing-elite-sm.f4bc59d7.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/battle-payments-clan-landing-elite-sm.png
// module id = 3708
// module chunks = 11